import { createSelector } from 'reselect';

import { dashboardSelector } from 'modules/v2/store/selectors/dashboard';

export const addressesSelector = createSelector(dashboardSelector, (state) => state.addresses);
